import { Link } from "@quintype/components";
import React, { useState, useEffect, useRef } from "react";
import PVLogo from "../../../../atoms/other-icons/PVLogo";
import Search from "../../../../atoms/other-icons/Search";
import Hamburger from "../../../../atoms/other-icons/Hamburger";
import HamburgerPage from "./hamburger";
import { useSelector } from "react-redux";
import { get } from "lodash";
import AccLoginBtn from "../../../../atoms/acc-login";
import AccountBtn from "../../../../atoms/account-btn";
import SubscribeBtn from "../../../../atoms/subscribe-btn";
import NewsletterBtn from "../../../../atoms/newsletter-btn";
import MenusChip from "../../../../atoms/menus-chip";

import DesktopNavItem from "./DesktopNavItem";

import "./desktop-header.m.css";
import CustomHeader from "../../custom-header";
import { SupportStrip } from "../../../../pages/subscribe-page/support-strip";

export default function DesktopHeader({ signinHandler, onAccountHandler, isHardcodedHeader, showSecondaryHeader = true, isSubscriber, showRedirectSupportStrip }) {
  const [isOpen, setIsOpen] = useState(false);

  const primaryMenus = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "primaryMenus"], []));
  const secondaryMenus = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "secondaryMenus"], []));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], null));

  const primaryMenuRef = useRef(null);
  const measureRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(0);

  // Dynamic menu item calculation
  useEffect(() => {
    let observer;
    const calculateVisibleItems = () => {
      if (!primaryMenuRef.current || !measureRef.current) return;

      const containerWidth = primaryMenuRef.current.offsetWidth;
      const measureItems = measureRef.current.children;

      let totalWidth = 0;
      let count = 0;

      for (let i = 0; i < measureItems.length; i++) {
        totalWidth += measureItems[i].offsetWidth;
        if (totalWidth > containerWidth) {
          break;
        }
        count++;
      }

      setVisibleCount(count);
    };

    const handleResize = () => {
      // Small delay to allow layout shifts to settle
      setTimeout(calculateVisibleItems, 100);
    };

    handleResize(); // Initial calculation

    // Listen for resize events
    window.addEventListener("resize", handleResize);

    // Also use ResizeObserver for more robust detection
    if (window.ResizeObserver && primaryMenuRef.current) {
      observer = new ResizeObserver(handleResize);
      observer.observe(primaryMenuRef.current);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (observer && primaryMenuRef.current) {
        observer.unobserve(primaryMenuRef.current);
      }
    };
  }, [primaryMenus]); // Recalculate if menus change

  // Hide body scroll when hamburger menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const hamburgerCloseHandler = () => {
    setIsOpen(false);
  };
  if (isHardcodedHeader !== "") {
    return (
      <CustomHeader
        isHardcodedHeader={isHardcodedHeader}
        signinHandler={signinHandler}
        onAccountHandler={onAccountHandler}
      />
    );
  }

  return (
    <>
      <header styleName="header-main">
        <div styleName="header-container">
          <Link href="/" styleName="logo-link">
            <PVLogo />
          </Link>

          <nav styleName="primary-menu" aria-label="Primary Navigation" ref={primaryMenuRef}>
            <ul styleName="primary-menu-list" style={{ position: "absolute", visibility: "hidden", whiteSpace: "nowrap" }} aria-hidden="true" ref={measureRef}>
              {primaryMenus.map((item, idx) => (
                <DesktopNavItem
                  key={`measure-${idx}`}
                  item={item}
                  currentPath={currentPath}
                  allMenus={primaryMenus}
                  currentIndex={idx}
                />
              ))}
            </ul>
            <ul styleName="primary-menu-list">
              {primaryMenus.slice(0, visibleCount).map((item, idx) => (
                <DesktopNavItem
                  key={idx}
                  item={item}
                  currentPath={currentPath}
                  allMenus={primaryMenus}
                  currentIndex={idx}
                />
              ))}
            </ul>
          </nav>

          <div styleName="header-actions">
            <Link href="/search" styleName="search-button" aria-label="Search">
              <Search color="black" />
            </Link>

            {!isSubscriber && <SubscribeBtn isVerificationPending={showRedirectSupportStrip} />}

            <AccountBtn signinHandler={signinHandler} onAccountHandler={onAccountHandler} />
            {/* <NewsletterBtn /> */}

            <button styleName="hamburger-button" aria-label="Menu" onClick={() => setIsOpen(true)}>
              <Hamburger color="black" />
            </button>

            {isOpen && (
              <div styleName="overlay">
                <div styleName={`overlay-content ${isOpen ? "slide-down" : ""}`}>
                  <HamburgerPage
                    signinHandler={() => signinHandler("ham_menu")}
                    onAccountHandler={onAccountHandler}
                    primaryMenus={primaryMenus}
                    secondaryMenus={secondaryMenus}
                    closeHandler={hamburgerCloseHandler}
                    currentPath={currentPath}
                    isSubscriber={isSubscriber}
                    isVerificationPending={showRedirectSupportStrip}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <div styleName={`header-secondary ${!showSecondaryHeader ? "header-secondary-hidden" : ""}`}>
        <div styleName="secondary-menu-container">
          <MenusChip menus={secondaryMenus} />
        </div>
      </div>

      { showRedirectSupportStrip && <SupportStrip showSecondaryHeader={showSecondaryHeader} />}
    </>
  );
}
